'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dNew$002dMessage$002dIn$002dChats from "./app.api.-General-Practice-App-Update$-New-Message-In-Chats.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ as $c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ };
$c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ as $h_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ };
$h_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$.prototype.toString__T = (function() {
  return "NewMessageInChats";
});
$c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$.prototype.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats = (function(x$0) {
  var ids$1 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dGeneral$002dPractice$002dApp$002dUpdate$0024$002dNew$002dMessage$002dIn$002dChats.$c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats(ids$1);
});
$c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats(p);
});
var $d_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$, "app.api.GeneralPracticeAppUpdate$NewMessageInChats$", ({
  Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ as $d_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ };
var $n_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$;
function $m_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$() {
  if ((!$n_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$)) {
    $n_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ = new $c_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$();
  }
  return $n_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$;
}
export { $m_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ as $m_Lapp_api_GeneralPracticeAppUpdate$NewMessageInChats$ };
//# sourceMappingURL=app.api.-General-Practice-App-Update$-New-Message-In-Chats$.js.map
